export interface DashboardRequest {
  isTotalStudent: boolean;
  isOccupiedStudent: boolean;
  isAvailableChair: boolean;
  isThisMonthEnquiries: boolean;
  isThisMonthRevenue: boolean;
  isTotalRevenue: boolean;
  isActiveStudent?: boolean;
  isInactiveStudent?: boolean;
}

export interface DashboardResponse {
  availableChairCount: number;
  totalChairCount: number;
  totalStudentCount: number;
  allottedStudentCount: number;
  unAllottedStudentCount: number;
  thisMonthEnquiries: number;
  thisMonthRevenue: number;
  totalRevenue: number;
  activeStudent?: number;
  inactiveStudent?: number;
}

export interface StudentValidityInfoResponse {
  fullName: string;
  mobileNumber: string;
  remainingDays: number;
  lastDate: string; // ISO date string from API (e.g., "2025-12-23")
}

export interface SmsWalletResponse {
  walletBalance: number;
  smsCount: number;
}

export const SMS_WALLET_LOW_BALANCE_THRESHOLD = 110;
